/* eslint-disable import/prefer-default-export */

import React from 'react';
import Link from '@ntuctech/devex-tangram/Link';

import { TNC_LINK_FPG, PRIVACY_NOTICE_FPG } from '../../../constants/clients';

export const TnCLink = (props) => {
  const { url, ...rest } = props;

  return (
    <Link href={url || TNC_LINK_FPG} target="_blank" size="s" {...rest}>
      Terms and Conditions
    </Link>
  );
};

export const PrivacyLink = (props) => {
  const { url, ...rest } = props;

  const fpgPrivacyUrl = PRIVACY_NOTICE_FPG;

  return (
    <Link href={url || fpgPrivacyUrl} target="_blank" size="s" {...rest}>
      {/* only show the new name when
       * url is not provided, i.e.,
       * the link is for FPG
       */}
      {!url ? 'Privacy Notice' : 'Privacy Policy'}
    </Link>
  );
};
